import CryptoJS from 'crypto-js';
import setting from './config.util';
import axios from 'axios';
import { getCookie } from './cookies.util';

const instance = axios.create({
  baseURL: '',
});

instance.interceptors.request.use(
  async (request) => {
    const accessToken = getCookie('token') || '';
    if (accessToken) {
      request.headers.Authorization = `Bearer ${accessToken}`;
    }
    const createdAt = new Date().getTime();
    const password = `${setting.APP_ENCRYPTION_KEY}${createdAt}`;
    const apiKey = CryptoJS.AES.encrypt(
      password,
      `${setting.APP_ENCRYPTION_KEY}`,
      {
        iv: setting.APP_IV as any,
      },
    ).toString();
    request.headers['Content-Type'] = 'application/json';
    request.headers['Access-Control-Allow-Methods'] =
      'GET, PUT, POST, DELETE, OPTIONS';
    request.headers['appType'] = 'Customer';
    request.headers['createdAt'] = createdAt;
    request.headers['apikey'] = apiKey;
    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default instance;
